import React from "react";
import { Box } from "@mui/material";
import { ShopItem } from "./ShopItem";

export const ShopItems = (props) => {
  const items = props.products?.result || [];
  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          xl: "repeat(4, 1fr)",
        },
      }}
    >
      {items.map((it) => (
        <ShopItem
          key={it.systemId || it.no}
          itemName={it.no}
          itemImage={it.image}
          itemDescription={it.description}
          itemPrice={it.unitPrice}
          itemId={it.no}
          itemCategory={it.itemCategoryCode}
          itemRadius={it.radius}
          itemWall={it.wall}
          itemDiameter={it.diameter}
          itemBrand={it.brand}
          itemAvailability={it.availableInventory}
          updateCartItemCount={props.updateCartItemCount}
        />
      ))}
    </Box>
  );
};
